import Vue from 'vue'
import MaskedInput from 'vue-masked-input'

Vue.component(MaskedInput.name, MaskedInput)
